const digest = '755c7372140a3db7cd3b36fa816b90bb1867d8c8472af75c81267e51dbde978b';
const css = `._cardArt_j1vul_1{height:38px;margin-top:3px;max-width:unset}@media (max-width:767px){._creditDetail_j1vul_8 span{display:block}}._imageContainer_j1vul_13{background-position:50%;background-size:cover;height:8rem;overflow:hidden}@media (max-width:767px){._imageContainer_j1vul_13{height:10rem}}@media (min-width:768px) and (max-width:1023px){._imageContainer_j1vul_13{height:7rem}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'cardArt': '_cardArt_j1vul_1', 'creditDetail': '_creditDetail_j1vul_8', 'imageContainer': '_imageContainer_j1vul_13' };
export const cardArt = '_cardArt_j1vul_1';
export const creditDetail = '_creditDetail_j1vul_8';
export const imageContainer = '_imageContainer_j1vul_13';
export { css, digest };